import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { runInAction, toJS } from 'mobx';
import MatchOddsModel from './model/odds';
import { ScoreDetailService } from '../../../../../../common/services';

const MatchOddsStore = (type) => {
  const store = useLocalStore(() => ({
    odds: null,
    loading: false,
    init: false,
    gameId: null,
    async getOddsSites(gameId) {
      store.loading = true;

      const result = await ScoreDetailService.getOddsSitesV2(gameId);

      return result;
    },
    getAll: async (gameId) => {
      store.loading = true;

      const [odds] = await Promise.all([store.getOddsSites(gameId)]);

      runInAction(() => {
        store.odds = new MatchOddsModel(odds);

        store.loading = false;
      });
    },
  }));

  return {
    getAll: store.getAll,
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        odds: store.odds,
      };
    }),
  };
};

export default MatchOddsStore;
